import { Controller } from '@hotwired/stimulus'
import store from '../store'
import * as sectionFragmentsStore from '../section-fragments-store'
import * as bootstrap from 'bootstrap';

export default class extends Controller {

  connect() {
    sectionFragmentsStore.add(this.provision)
    this.isOpen = this.element.dataset.isNewProvision === 'true'
    if(this.isOpen) {
      store.selectedProvision.set(this.provision)
    }
    this.abortController = new AbortController()
    this.element.addEventListener('shown.bs.collapse', this.selected.bind(this), { signal: this.abortController.signal })
    this.element.addEventListener('hidden.bs.collapse', this.deselected.bind(this), { signal: this.abortController.signal })
    this.effects = [
      store.selectedProvision.effect(() => {
        if(!this.isActiveProvision && this.isOpen) {
          bootstrap.Collapse.getOrCreateInstance(this.element).hide()
        }
      })
    ]
  }

  disconnect() {
    this.deselected()
    this.abortController.abort()
    this.effects.forEach(dispose => dispose())
    sectionFragmentsStore.remove(this.provision.provisionSqid)
  }

  get provision() {
    if(!this._provision) {
      this._provision = JSON.parse(this.element.dataset.provision)
    }
    return this._provision
  }

  get isActiveProvision() {
    return store.selectedProvision.value.provisionSqid === this.provision.provisionSqid
  }

  get firstFragment() {
    if(!this._firstFragment && this.provision.fragmentIds[0]) {
      this._firstFragment = document.getElementById(this.provision.fragmentIds[0])
    }
    return this._firstFragment
  }

  selected() {
    this.isOpen = true
    store.selectedProvision.set(this.provision)
    if(this.firstFragment) {
      this.firstFragment.scrollIntoView({ block: "center" })
    }
  }

  deselected() {
    this.isOpen = false
    if(this.isActiveProvision) {
      store.selectedProvision.set({})
    }
  }

  morphed() {
    this._provision = null
    this._firstFragment = null
    if(this.isActiveProvision) {
      store.selectedProvision.set(this.provision)
    }
    sectionFragmentsStore.edit(this.provision)
  }

  focusOnFragment(e) {
    document.getElementById(e.currentTarget.dataset.fragmentId)?.focus()
  }
}
